var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-control',{attrs:{"label":"Font Weight"}},[_c('dropdown',{attrs:{"theme":"minimalistic","placeholder":"Select Weight","options":_vm.options,"value":_vm.fontWeight,"native":""},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }